import {
  HTTP_INTERCEPTORS,
  HttpEvent,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";

import { TokenStorageService } from "../_services/token-storage.service";
import { EMPTY, Observable, finalize, switchMap } from "rxjs";
import jwt_decode from "jwt-decode";
import { UserService } from "../_services/user.service";

const TOKEN_HEADER_KEY = "accessToken";
const TOKEN_HEADER_KEY_AUTH = "Authorization";
const TOKEN_REFRESH_THRESHOLD_SECONDS = 120;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(
    private tokenService: TokenStorageService,
    private userService: UserService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.tokenService.getToken();
    if (token == null) {
      return next.handle(req);
    }

    const decodedToken: any = jwt_decode(token);
    const now = Math.floor(Date.now() / 1000);
    const expired = now >= decodedToken.exp;

    if (expired) {
      this.tokenService.signOutExpirationAndRedirectTo("login");
      window.location.reload();
      return EMPTY;
    }

    const shouldRefresh =
      decodedToken.exp - now <= TOKEN_REFRESH_THRESHOLD_SECONDS;

    if (shouldRefresh && !this.isRefreshing) {
      this.isRefreshing = true;
      return this.userService.updateTokenExpiration().pipe(
        switchMap((data: any) => {
          if (data.status == "616") {
            this.tokenService.saveToken(data.token);
            this.userService.getCurrentUserFromServer().subscribe({
              next: (data) => {
                if (data.Usuario != null) {
                  this.tokenService.setUser(
                    data.Usuario,
                    data.usuarioRepresenta
                  );
                }
              },
            });
            return next.handle(
              this.withAuthHeaders(req, data.token as string)
            );
          }
          this.tokenService.signOutExpirationAndRedirectTo("login");
          return EMPTY;
        }),
        finalize(() => {
          this.isRefreshing = false;
        })
      );
    }

    return next.handle(this.withAuthHeaders(req, token));
  }

  private withAuthHeaders(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({
      headers: req.headers
        .set(TOKEN_HEADER_KEY_AUTH, "Bearer " + token)
        .set(TOKEN_HEADER_KEY, token),
    });
  }
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
];
